import React, { useEffect, useState } from 'react'
import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { StyledButton } from '../../../theme/Global'
import { RadioList } from './components/radioList'
import { AutoCompleteList } from './components/autoCompleteList'
import { CustomPaper, StyledSelectionBox } from './styles'
import * as httpClient from '../../../clients/httpClient'
import LoadingSpinner from '../../../app/components/apiLoadingSpinner'

const SelectCompanyContext = (props) => {
  const {
    companyList,
    selectedCompany,
    currentCompany,
    setSelectedCompany,
    getCompany,
    loading,
    user
  } = props
  const [companies, setCompanies] = useState(user && user.isAdmin ? [] : companyList)
  const [companiesLoading, setLoading] = useState(false)
  const [currentUserCompany, setCurrentUserCompany] = useState(null)

  const mapCompanyToSelect = (company) => (company ? ({
    value: company._id,
    label: company.displayName
  }) : {})

  // todo: search for companies on debounced text input instead of storing the world
  const getAllCompanies = async ({ subscribed }) => {
    setLoading(true)
    try {
      const companiesResponse = (await httpClient.getJsonResponse({
        path: '/companies',
        method: 'GET',
        queryParameters: {
          pageSize: 10000,
          pageNumber: 1,
          dashboardOnly: 'true'
        }
      })).body
      const companyDocs = companiesResponse && companiesResponse.data && companiesResponse.data.companies
      const companySelectDtos = () => companyDocs.map(mapCompanyToSelect)
      if (subscribed) {
        setCompanies(companySelectDtos)
        if (currentCompany && companyDocs) {
          const company = companyDocs.find(
            (_company) => _company._id === currentCompany._id
          )
          setCurrentUserCompany(mapCompanyToSelect(company))
          setSelectedCompany(mapCompanyToSelect(company))
        }
        setLoading(false)
      }
    } catch (error) {
      console.error('Error while trying to retrieve the companies', error)
      if (subscribed) setLoading(false)
    }
  }

  useEffect(() => {
    let subscribed = true
    if (user && user.isAdmin) {
      getAllCompanies({ subscribed }).catch((error) => {
        console.error('caught error from selectCompany -> getAllCompanies', error)
        throw error
      })
    } else if (subscribed) {
      setCompanies(companyList)
      setCurrentUserCompany(currentCompany)
    }

    return () => (subscribed = false)
  }, [companyList])

  return (
    <Grid item xs={12} lg={12}>
      <CustomPaper data-testid="select-company-context">
        <Typography
          data-testid="select-company-title"
          variant="h5"
        >{currentCompany ? 'Switch Company' : 'Select Company'}
        </Typography>
        {companiesLoading ? <LoadingSpinner withoutPaper /> : (
          <StyledSelectionBox>
            {companies.length > 6 || (user && user.isAdmin)
              ? (
                <AutoCompleteList
                  height="1.3rem"
                  {...{
                    companyList: companies,
                    selectedCompany,
                    setSelectedCompany,
                    isAdmin: user.isAdmin
                  }}
                />
              )
              : (
                <RadioList {...{
                  companyList: companies,
                  selectedCompany,
                  setSelectedCompany
                }}
                />
              )}
          </StyledSelectionBox>
        )}
        <StyledButton
          data-testid="select-company-button"
          variant="contained"
          disabled={!selectedCompany || selectedCompany.label === '' || loading || (currentUserCompany && currentUserCompany.value === selectedCompany.value)}
          onClick={() => getCompany()}
        >
          {loading ? <CircularProgress size={16} style={{ marginRight: '10px' }} /> : null}
          {currentCompany ? 'Switch' : 'Continue'}
        </StyledButton>
      </CustomPaper>
    </Grid>
  )
}

export default SelectCompanyContext
